import { Theme } from '@mui/material';
import config from '@shared/config';


const Button = (theme: Theme) => {
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: config.theme.disableRipple,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: config.theme.elevation === 0,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
      variants: [
        {
          props: { variant: 'text', color: 'primary' },
          style: {
            '&:hover': {
              background: theme.palette.primary.main + '30',
            },
          },
        },
        {
          props: { variant: 'contained', color: 'secondary' },
          style: {
            color: '#fff',
          },
        },
      ],
    },
  };
};

export default Button;
